import { render, staticRenderFns } from "./hotNews.vue?vue&type=template&id=3db1f1af&"
import script from "./hotNews.vue?vue&type=script&lang=js&"
export * from "./hotNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports